import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { OCCViewerService } from './occ-viewer.service';
import { OCCViewerComponent } from './occ-viewer.component';
import { UpdateIndicatorModule } from '@shared/update-indicator/update-indicator.module';

@NgModule({
  imports: [CommonModule, TranslateModule, UpdateIndicatorModule],
  declarations: [OCCViewerComponent],
  exports: [OCCViewerComponent],
  providers: [OCCViewerService],
})
export class OCCViewerModule {}
